import axiosAgent from './axiosAgent';
import Apiconfig from '../config/ApiConfig';

export const AddUser = async (values, toast, optional, addSingle) => {
    console.log('addSingle', addSingle);
    try {
        const response = await axiosAgent.post(Apiconfig.auth.register, values);
        console.log('Register res', response.values);
        if (response.data.success) {
            toast.success(response.data.message);
            addSingle ? optional('/dashboard/users') : optional();
        } else {
            toast.error('Please! checkin all your fields.');
            toast.error(response.data.message);
        }
    } catch (err) {
        toast.error('Please! checkin all your fields.');
        console.log('Error caught', err);
        toast.error('Error caught', err.message);
    }
};

export const blockUser = async (id) => {
    const res = await axiosAgent.post(`${Apiconfig.users.blockUser}/${id}`, {});
    return res;
};

export const unBlockUser = async (id) => {
    const res = await axiosAgent.post(
        `${Apiconfig.users.unBlockUser}/${id}`,
        {}
    );
    return res;
};
